module.exports = __webpack_public_path__ + "static/media/camera_enhance.07cd2c42.svg";